import React, { useRef } from 'react';
import { buildSvgEvents } from './svgCommonEvents';
import PropTypes from 'prop-types';

const IconDelete = ({
    disabled = false,
    onClick,
    fill,
    size = 50,
    style,
    ...props
}) => {
    const ref = useRef(null);

    return (
        <svg
            ref={ref}
            height={size}
            fill={disabled ? '#cccccc' : fill}
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 42.313999 50'
            style={{
                cursor: disabled ? 'default' : 'pointer',
                ...style
            }}
            {...buildSvgEvents(ref, disabled, onClick, fill)}
            {...props}
        >
            <g strokeWidth={0.664}>
                <path d='M42.012 11.602c-.602 0-1.204-.151-1.807-.151v-.753c0-2.56-.3-2.861-2.86-2.861h-6.777V6.632c-.15-3.915-3.313-6.776-6.927-6.625-1.957.15-3.915.15-5.722 0-2.108-.15-5.571 2.258-6.023 4.668a39.895 39.895 0 01-.602 3.313H3.915c-1.506 0-1.957.451-1.957 1.957 0 1.657 0 1.657-1.657 1.807 0 0-.15 0-.301.15v3.464c1.054 0 1.807.15 2.71.15 1.055-.15 1.205.302 1.205 1.205 0 9.186.15 18.522 0 27.707 0 2.71 3.012 5.572 5.421 5.572h23.642c2.71 0 5.42-3.012 5.42-5.572-.15-9.185 0-18.37 0-27.707v-1.355h3.916v-3.764zM18.07 3.772c1.807 0 3.614.15 5.27 0 2.259-.151 3.765 1.806 3.162 3.914H15.51c-.602-2.108.602-3.915 2.56-3.915zm16.413 39.753c0 1.958-.602 2.56-2.56 2.56H9.788c-1.506 0-2.259-.602-2.259-2.108v-28.16c0-.15 0-.15.15-.45h25.75c1.054 0 1.355.3 1.205 1.354-.15 8.885-.15 17.92-.15 26.804z' />
                <path d='M11.595 19.13h3.614v22.89h-3.614zM19.124 19.13h3.614v22.89h-3.614zM26.954 19.13h3.464v22.89h-3.464z' />
            </g>
        </svg>
    );
};

IconDelete.defaultProps = {
    disabled: false,
    size: 50
};

IconDelete.propTypes = {
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    size: PropTypes.any,
    style: PropTypes.object,
    fill: PropTypes.any
};

export default IconDelete;
